import React from 'react';
import BindsRow from '../BindsRow/BindsRow';
import Bind from '../Bind/Bind';
import { getValueByPath } from '../../../../../../helpers/getValueByPath';
import BindTitle from '../BindTitle/BindTitle';
import styles from './CompanyBinds.module.scss';

const CompanyBinds = ({ binds }) => {
  return (
    <div className={styles.root}>
      <BindTitle>Управляющие компании</BindTitle>
      <BindsRow size="lg">
        {binds.map((bind) => (
          <Bind
            key={bind.id}
            color="#108ee9"
            content={getValueByPath(bind, 'serviceCompany.name')}
            item={bind}
          />
        ))}
      </BindsRow>
    </div>
  );
};

export default CompanyBinds;
